"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT_ROLES = exports.EMPLOYEE_ROLES = exports.AM_OPS_ROLES = exports.AM_ROLES = exports.PRODUCER_ROLES = exports.AuthRole = void 0;
/**
 * Newfront Auth Roles
 */
var AuthRole;
(function (AuthRole) {
    AuthRole["ACCOUNT_MANAGER"] = "AccountManager";
    AuthRole["AM_MANAGER"] = "AMManager";
    AuthRole["BPO_MANAGER"] = "BPOManager";
    AuthRole["BPO_TECHTAMMINA"] = "BPOTechTammina";
    AuthRole["BPO_WORKER"] = "BPOWorker";
    AuthRole["CARRIER_RELATIONS"] = "CarrierRelations";
    AuthRole["CERTIFICATE_EDITOR"] = "CertificateEditor";
    AuthRole["CERTIFICATE_VIEWER"] = "CertificateViewer";
    AuthRole["CLAIM_EDITOR"] = "ClaimEditor";
    AuthRole["CLAIM_VIEWER"] = "ClaimViewer";
    AuthRole["CLIENT"] = "Client";
    AuthRole["CLIENT_ADMIN"] = "ClientUserAdmin";
    AuthRole["CLIENT_SERVICE_TEAM_ADMIN"] = "ClientServiceTeamAdmin";
    AuthRole["CLIENT_USER"] = "ClientUser";
    AuthRole["CL_ACCOUNT_MANAGER"] = "CommercialLinesAccountManager";
    AuthRole["CL_PRODUCER"] = "CommercialLinesProducer";
    AuthRole["CONVERSION"] = "Conversion";
    AuthRole["CSA"] = "ClientServiceAssociate";
    AuthRole["EB_ACCOUNT_MANAGER"] = "EmployeeBenefitsAccountManager";
    AuthRole["EB_PRODUCER"] = "EmployeeBenefitsProducer";
    AuthRole["ENGINEER"] = "Engineer";
    AuthRole["EXECUTIVE"] = "Executive";
    AuthRole["FINANCE"] = "Finance";
    AuthRole["GROWTH_CALLER"] = "GrowthCaller";
    AuthRole["INSURABLE_ITEM_VIEWER"] = "InsurableItemViewer";
    AuthRole["INSURANCE_OPS"] = "InsuranceOps";
    AuthRole["INVOICE_EDITOR"] = "InvoiceEditor";
    AuthRole["INVOICE_VIEWER"] = "InvoiceViewer";
    AuthRole["OPERATIONS"] = "Operations";
    AuthRole["PL_ACCOUNT_MANAGER"] = "PersonalLinesAccountManager";
    AuthRole["PL_PRODUCER"] = "PersonalLinesProducer";
    AuthRole["POLICY_CHANGE_EDITOR"] = "PolicyChangeEditor";
    AuthRole["POLICY_VIEWER"] = "PolicyViewer";
    AuthRole["PRODUCER"] = "Producer";
    AuthRole["PRODUCER_MANAGER"] = "ProducerManager";
    AuthRole["RISK_MANAGER"] = "RiskManager";
    AuthRole["SALES_MANAGER"] = "SalesManager";
    AuthRole["SERVICE"] = "Service";
    AuthRole["SERVICE_OPS"] = "ServiceOps";
    AuthRole["SGA"] = "StrategicGrowthAssociate";
})(AuthRole = exports.AuthRole || (exports.AuthRole = {}));
/**
 * Encapsulates all producer roles
 */
exports.PRODUCER_ROLES = [
    AuthRole.CL_PRODUCER,
    AuthRole.EB_PRODUCER,
    AuthRole.PL_PRODUCER,
    AuthRole.PRODUCER,
];
/**
 * Encapsulates all account manager roles
 */
exports.AM_ROLES = [
    AuthRole.ACCOUNT_MANAGER,
    AuthRole.CL_ACCOUNT_MANAGER,
    AuthRole.PL_ACCOUNT_MANAGER,
    AuthRole.EB_ACCOUNT_MANAGER,
];
/**
 * Encapsulates all internal roles (including BPO) except producers
 */
exports.AM_OPS_ROLES = [
    AuthRole.ACCOUNT_MANAGER,
    AuthRole.AM_MANAGER,
    AuthRole.BPO_MANAGER,
    AuthRole.BPO_TECHTAMMINA,
    AuthRole.BPO_WORKER,
    AuthRole.CLIENT_SERVICE_TEAM_ADMIN,
    AuthRole.CL_ACCOUNT_MANAGER,
    AuthRole.CONVERSION,
    AuthRole.CSA,
    AuthRole.EB_ACCOUNT_MANAGER,
    AuthRole.ENGINEER,
    AuthRole.EXECUTIVE,
    AuthRole.FINANCE,
    AuthRole.GROWTH_CALLER,
    AuthRole.INSURANCE_OPS,
    AuthRole.OPERATIONS,
    AuthRole.PL_ACCOUNT_MANAGER,
    AuthRole.PRODUCER_MANAGER,
    AuthRole.RISK_MANAGER,
    AuthRole.SALES_MANAGER,
    AuthRole.SERVICE_OPS,
    AuthRole.SGA,
];
/**
 * Encapsulates all internal roles
 */
exports.EMPLOYEE_ROLES = [...exports.PRODUCER_ROLES, ...exports.AM_OPS_ROLES];
/**
 * Encaspsulates all external roles
 */
exports.CLIENT_ROLES = [
    AuthRole.CERTIFICATE_EDITOR,
    AuthRole.CERTIFICATE_VIEWER,
    AuthRole.CLAIM_EDITOR,
    AuthRole.CLAIM_VIEWER,
    AuthRole.CLIENT,
    AuthRole.CLIENT_ADMIN,
    AuthRole.CLIENT_USER,
    AuthRole.INSURABLE_ITEM_VIEWER,
    AuthRole.INVOICE_EDITOR,
    AuthRole.INVOICE_VIEWER,
    AuthRole.POLICY_CHANGE_EDITOR,
    AuthRole.POLICY_VIEWER,
];
//# sourceMappingURL=auth-role.js.map